import React from "react";
import ReactEcharts from "echarts-for-react";
import i18n from '../../i18n';
// Chart option objects are built in plain helper functions and default
// parameters, where React hooks cannot be called — so translate through the
// i18n instance directly. Charts re-render when their page re-renders on a
// language change, so labels stay in sync.
const t = (key, opts) => i18n.t(key, opts);

const EchartBar = (props) => {
  const yseries =
    props.data.sexing === "yes"
      ? [
          {
            name: t('charts:legend.maleMortality'),
            type: "bar",
            barWidth: "30%",
            data: props.data.yAxis,
          },
          {
            name: t('charts:legend.femaleMortality'),
            type: "bar",
            barWidth: "30%",
            data: props.data.yAxis2,
          },
        ]
      : [
          {
            name: props.category,
            type: "bar",
            barWidth: "30%",
            data: props.data.yAxis,
          },
        ];

  const options = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    // grid: {
    //   left: 40,
    //   top: 10,
    //   right: 35,
    //   bottom: 60,
    //   containLabel: true,
    // },
    xAxis: [
      {
        type: "category",
        data: props.data.xAxis,
        axisTick: {
          alignWithLabel: true,
        },
        name: t('charts:common.date'),
        nameLocation: "middle",
        nameGap: 30,
      },
    ],
    yAxis: [
      {
        type: "value",
        name: props.ylabel,
        nameLocation: "middle",
        nameGap: 50,
      },
    ],
    series: yseries,
    dataZoom: [
      {
        type: "slider",
      },
      {
        handleIcon:
          "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        handleSize: "80%",
      },
    ],
  };

  return (
    <div className="Temp">
      {props.data.xAxis?.length > 0 ? (
        <ReactEcharts
          option={options}
          style={{ height: "300px", width: "100%" }}
          opts={{ renderer: "svg" }}
        />
      ) : (
        <div className="text-center">{t('charts:common.noDataFound')}</div>
      )}
    </div>
  );
};

export default EchartBar;

// import React, { useMemo } from "react";
// import ReactEcharts from "echarts-for-react";

// const EchartBar = (props) => {
//   const { data, category, ylabel } = props;

//   const yseries = useMemo(() => {
//     if (data.sexing === "yes") {
//       return [
//         {
//           name: t('charts:legend.maleMortality'),
//           type: "bar",
//           barWidth: "30%",
//           data: data.yAxis,
//         },
//         {
//           name: t('charts:legend.femaleMortality'),
//           type: "bar",
//           barWidth: "30%",
//           data: data.yAxis2,
//         },
//       ];
//     } else {
//       return [
//         {
//           name: category,
//           type: "bar",
//           barWidth: "30%",
//           data: data.yAxis,
//         },
//       ];
//     }
//   }, [data, category]);

//   const options = useMemo(() => {
//     return {
//       tooltip: {
//         trigger: "axis",
//         axisPointer: {
//           type: "shadow",
//         },
//         formatter: (params) => {
//           const index = params[0].dataIndex;

//           if (data.sexing === "yes") {
//             const male = params.find((p) => p.seriesName === t('charts:legend.maleMortality'))?.value ?? "-";
//             const female = params.find((p) => p.seriesName === t('charts:legend.femaleMortality'))?.value ?? "-";
//             const maleAcc = data.maleAccumulatedWeights?.[index] ?? "-";
//             const femaleAcc = data.femaleAccumulatedWeights?.[index] ?? "-";

//             return `
//               <table style="border-collapse:collapse;">
//                 <thead>
//                   <tr>
//                     <th style="padding:4px; border-bottom:1px solid #ccc;">Type</th>
//                     <th style="padding:4px; border-bottom:1px solid #ccc;">Mortality</th>
//                     <th style="padding:4px; border-bottom:1px solid #ccc;">Accumulated</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td style="padding:4px;">Male</td>
//                     <td style="padding:4px;">${male}</td>
//                     <td style="padding:4px;">${maleAcc}</td>
//                   </tr>
//                   <tr>
//                     <td style="padding:4px;">Female</td>
//                     <td style="padding:4px;">${female}</td>
//                     <td style="padding:4px;">${femaleAcc}</td>
//                   </tr>
//                 </tbody>
//               </table>
//             `;
//           } else {
//             const total = params[0]?.value ?? "-";
//             const totalAcc = data.accumulatedWeights?.[index] ?? "-";

//             return `
//               <table style="border-collapse:collapse;">
//                 <thead>
//                   <tr>
//                     <th style="padding:4px; border-bottom:1px solid #ccc;">Type</th>
//                     <th style="padding:4px; border-bottom:1px solid #ccc;">Mortality</th>
//                     <th style="padding:4px; border-bottom:1px solid #ccc;">Accumulated</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td style="padding:4px;">Total</td>
//                     <td style="padding:4px;">${total}</td>
//                     <td style="padding:4px;">${totalAcc}</td>
//                   </tr>
//                 </tbody>
//               </table>
//             `;
//           }
//         },
//       },
//       grid: {
//         left: 40,
//         top: 10,
//         right: 35,
//         bottom: 60,
//         containLabel: true,
//       },
//       xAxis: [
//         {
//           type: "category",
//           data: data.xAxis,
//           axisTick: {
//             alignWithLabel: true,
//           },
//           name: t('charts:common.date'),
//           nameLocation: "middle",
//           nameGap: 30,
//         },
//       ],
//       yAxis: [
//         {
//           type: "value",
//           name: ylabel,
//           nameLocation: "middle",
//           nameGap: 50,
//         },
//       ],
//       series: yseries,
//       dataZoom: [
//         {
//           type: "slider",
//         },
//         {
//           handleIcon:
//             "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
//           handleSize: "80%",
//         },
//       ],
//     };
//   }, [data, ylabel, yseries]);

//   return (
//     <div className="echart-bar-wrapper">
//       {data?.xAxis?.length > 0 ? (
//         <ReactEcharts
//           option={options}
//           style={{ height: "300px", width: "100%" }}
//           opts={{ renderer: "svg" }}
//         />
//       ) : (
//         <div className="text-center">{t('charts:common.noDataFound')}</div>
//       )}
//     </div>
//   );
// };

// export default EchartBar;
